import React, { useEffect, useState, } from 'react'
import ProgramSearchResult from './ProgramSearch/ProgramSearchResult'
import ProgramSearchEmpty from './ProgramSearch/ProgramSearchEmpty'
import { useLocation, } from 'react-router-dom'
import PropTypes from 'prop-types'

const noop = () => {}

const SearchResults = ({
  activeMapProgramId = null,
  activeMapProgramType = null,
  emptyMessage = null,
  mapBounds = null,
  mapDispatch = null,
  results = [],
  setActiveProgramId = noop,
}) => {
  const { pathname, } = useLocation()
  const resultsToRender = results || []
  const [ filteredResults, setFilteredResults, ] = useState([])
  
  useEffect(() => {
    if (results && typeof dataLayer !== 'undefined') {
      // eslint-disable-next-line no-undef
      dataLayer.push({ 'event': 'directorySearchResultsChanged' , })
    }
  }, [ results, ])

  React.useEffect(() => {
    if (!activeMapProgramId) {
      let filtered = results.filter((r) => {
        if (mapBounds === null || mapBounds === undefined) {
          return true
        } 
        if (r.addresses === null || r.addresses === undefined || r.addresses.length <= 0) {
          return true
        } else {          
          for (let idx = 0; idx < r.addresses.length; idx++) {
            if (r.addresses[idx].lat && r.addresses[idx].lon && mapBounds.contains({ lat: r.addresses[idx].lat, lng: r.addresses[idx].lon, })) { 
              return true
            }
          }
        }
        return false
      })
      setFilteredResults(filtered)
    }

  },[ results, mapBounds, activeMapProgramId, ])

  if (!resultsToRender || resultsToRender.length === 0 || !Array.isArray(resultsToRender)){
    return <ProgramSearchEmpty message={emptyMessage} />
  }

  if (filteredResults.length === 0) {
    return <ProgramSearchEmpty message={'No results in the selected map region. Zoom out or move the map to view results.'} />
  }

  return  filteredResults.map((r) => {
    let address = null
    if (r.primary_contact) {
      if (r.primary_contact.address && r.primary_contact.address.address) {
        address = r.primary_contact.address.address
      }
    }
    if (r.addresses && r.addresses.length > 0) {
      for (let idx = 0; (idx < r.addresses.length) && (address === null); idx++) {
        if (r.addresses[idx] && r.addresses[idx].address) {
          address = r.addresses[idx].address
        }
      }
    }
    let relevantId = r.program_occupation_id
    if (relevantId == null || relevantId === undefined) {
      relevantId = r.program_id
    }
    return <ProgramSearchResult
      activateProgramId={setActiveProgramId}
      address={address}
      baseHourlyWage={r.base_hourly_wage}
      categories={r.categories}
      isActive={activeMapProgramId === relevantId && activeMapProgramType === r.type}
      key={`search-res-${r.type}-${r.program_id}-${r.program_occupation_id ?? 0}`}
      mapDispatch={mapDispatch}
      occupationName={r.occupation_name}
      pathname={pathname}
      programMainTitle={r.main_title}
      programName={r.program_name}
      programOccupationId={relevantId}
      programOtherTitle={r.other_title}
      programType={r.type}
    />
  })
}

SearchResults.propTypes = {
  activeMapProgramId   : PropTypes.number,
  activeMapProgramType : PropTypes.string,
  emptyMessage         : PropTypes.string,
  mapBounds            : PropTypes.object,
  mapDispatch          : PropTypes.func,
  results              : PropTypes.array,
  setActiveProgramId   : PropTypes.func,
  toggleMobileMap      : PropTypes.func,
}

export default SearchResults
